// The pop-up on the homepage, once a visit, when you've scrolled past Chandigarh: a boarding pass that says the
// waitlist is open. It docks at the corner (a slim sheet on a phone) without covering the page. The game isn't open,
// so it never offers Play: it offers the waitlist (₹49, your name), and logging in to see your place. Anyone already
// on the list (a name claimed on this device, or on their account) doesn't get it at all.
import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useAccount } from './account';
import { REG } from './brand';
import { Wheel } from './landing/Wheel';
import { loadRegistered, openRegister } from './Register';
import { navigate } from './router';

/** true when there's no point showing it: already a founder */
export function onTheList(me: ReturnType<typeof useAccount>) {
  return !!(me?.claim || loadRegistered());
}

export function PlayCard({ onClose }: { onClose: () => void }) {
  const me = useAccount();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    addEventListener('keydown', onKey);
    return () => removeEventListener('keydown', onKey);
  }, [onClose]);

  if (onTheList(me)) return null;
  return createPortal(
    <aside className="gx-board" role="dialog" aria-modal="false" aria-labelledby="gx-board-title">
      <div className="b-top mono">
        <span>
          <i /> Waitlist open
        </span>
        <span>GG Bharat</span>
      </div>
      <button type="button" className="x" onClick={onClose} aria-label="Close">
        ×
      </button>
      <div className="route" aria-hidden>
        <div>
          <small className="mono">From</small>
          <b>YOU</b>
          <span>Anywhere</span>
        </div>
        <Wheel className="w" />
        <div>
          <small className="mono">To</small>
          <b>CHD</b>
          <span>The City Beautiful</span>
        </div>
      </div>
      <h2 id="gx-board-title">{me ? `Founders board first, ${me.displayName}.` : 'Founders board first.'}</h2>
      <p>Chandigarh isn’t open yet. Join the waitlist for ₹{REG.fee}: your GG Bharat name is yours for good, and founders get in first.</p>
      <div className="acts">
        <button
          type="button"
          className="gx-btn"
          onClick={() => {
            onClose();
            openRegister();
          }}
        >
          Join the waitlist · ₹{REG.fee}
        </button>
        {me ? (
          <button type="button" className="gx-btn ghost" onClick={onClose}>
            Later
          </button>
        ) : (
          <button type="button" className="gx-btn ghost" onClick={() => navigate('/login')}>
            Log in
          </button>
        )}
      </div>
      <div className="tear mono" aria-hidden>
        <span>Gate · Sector 17</span>
        <span>Seat · Any</span>
        <span>Class · Founder</span>
      </div>
    </aside>,
    document.body,
  );
}
